export default __webpack_public_path__ + "static/media/circle_2.4bd40acb.svg";